

































































import { defineComponent } from '@vue/composition-api';
import { mapMutations } from 'vuex';
import ERPRepository from '@/repositories/ERPRepository';
import AccountsLogRepository from '@/repositories/AccountsLogRepository';
import DialogHelper from '@/helpers/DialogHelper';
import InputRulesHelper from '@/helpers/InputRulesHelper';
import { VForm } from '@/types/VForm';
import ERPEventsEnum from '@/domain/enums/ERPEventsEnum';
import AccountActionsEnum from '@/repositories/parameters/AccountLogs/enums/AccountActionsEnum';
import PaymentRemittance from '@/domain/models/PaymentRemittance';

export default defineComponent({
  name: 'ChangeValueDialog',
  props: {
    open: {
      required: true,
      type: Boolean,
    },
    items: {
      required: true,
      type: Array as () => Array<PaymentRemittance>,
    },
  },
  computed: {
    ...mapMutations(['triggerEventSend']),
    dialogWidth(): string {
      return DialogHelper.getDialogWidth(this.$vuetify.breakpoint, {
        smAndDown: '100%',
        md: '60%',
        default: '40%',
      });
    },
    companyGroupId(): number {
      return Number(this.$session.get('company_group_id'));
    },
  },
  watch: {
    open(): void {
      this.isOpen = this.open;
      if (this.open && this.items.length > 0) {
        this.financialValue = this.items[0].total?.toString() || '';
      }
    },
  },
  data() {
    const inputRules: InputRulesHelper = new InputRulesHelper();
    const erpRepository: ERPRepository = new ERPRepository();
    const accountsLogRepository: AccountsLogRepository = new AccountsLogRepository();

    const financialValue: string = '';
    const loading: boolean = false;
    const isOpen: boolean = this.open;

    return {
      inputRules,
      erpRepository,
      accountsLogRepository,
      financialValue,
      loading,
      isOpen,
    };
  },
  methods: {
    async changeValue(): Promise<void> {
      try {
        this.loading = true;

        const item = this.items[0];

        const useNCC = Boolean(this.$session.get('use_ncc')) && item.type === 'NCC';

        const tableName = useNCC ? 'account_receivable' : 'account_payable';
        const identifyValue = useNCC ? 'CR' : 'CP';

        const valueAsNumber = Number(this.financialValue);

        const response = await Promise.allSettled([
          this.erpRepository.updateExternalERP(
            this.companyGroupId,
            item.company_id,
            {
              id: item.id_customer,
              event: ERPEventsEnum.INNCASH_VALUE,
              data: {
                inncash_value: valueAsNumber,
                type: tableName,
              },
            },
          ),

          this.erpRepository.updateInternalERP({
            id: item.id,
            field: useNCC ? 'e1_zvalinn' : 'e2_zvalinn',
            identify_values: identifyValue,
            value: valueAsNumber,
          }),

          this.erpRepository.saveDataInternalTable({
            _identifyValue: identifyValue,
            _field: 'valor',
            _date: undefined,
            _keyId: item.id_customer,
            _data: String(valueAsNumber),
          }),
        ]);

        if (!response.every((r) => r.status === 'fulfilled')) {
          throw new Error();
        }

        await this.accountsLogRepository.createLog(
          this.companyGroupId,
          {
            type: useNCC ? 'receivable' : 'payable',
            company_id: item.company_id,
            action: AccountActionsEnum.CHANGE_VALUE,
            content: 'Alteração de valor feita com sucesso.',
            id_customer: item.id_customer,
          },
        );

        this.$notification.success('Valor alterado com sucesso!');
        this.close();
      } catch (error) {
        this.$notification.error('Houve um problema ao alterar o valor.');
      } finally {
        this.loading = false;
      }
    },
    close(): void {
      this.$emit('close', { type: 'change-value', reload: true });
    },
    handleChangeValue(): void {
      const changeValueForm = this.$refs.ChangeValueForm as VForm;

      if (!changeValueForm.validate()) {
        this.$notification.error('Há campos preenchidos incorretamente!');
        return;
      }

      this.changeValue();
    },
  },
});
